import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InformacoesOperacao } from 'app/interfaces/Operacao';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OfensorProdutividade } from 'app/interfaces/OfensorProdutividade';
import { OfensoresProdutividadeComponent } from '../ofensores-produtividade/ofensores-produtividade.component';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-informacoes-operacao',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    OfensoresProdutividadeComponent,
    TranslocoModule
  ],
  templateUrl: './informacoes-operacao.component.html',
  styleUrl: './informacoes-operacao.component.css'
})
export class InformacoesOperacaoComponent {

  constructor(private translocoService: TranslocoService) {}

  @Input() operacoesInformacoes: InformacoesOperacao[] = [];
  @Input() ofensoresProdutividade: OfensorProdutividade = {};
  @Input() isLoading: boolean = false;

  get informacoesOperacao(): InformacoesOperacao {
    return this.operacoesInformacoes?.[0];
  }

  public formatarEstado(estado: string): string {
    return this.translocoService.translate(
      `COMPONENTS.INFORMACOES_OPERACAO.status.${estado}`
    );
  }

  public formatarData(data?: string): string {
    if (!data) return '';
    const date = new Date(data);
    return date.toLocaleDateString();
  }

  public formatarHora(hora?: string): string {
    if (!hora) return '';
    return hora.substring(0, 5);
  }
}